export function translate(translations, key, options) {
  return applyOptions(translations[key] ?? '', options);
}
function applyOptions(value, options) {
  if (options === void 0) {
    options = {};
  }
  return Object.keys(options).reduce((acc, option) => acc.replace(new RegExp(`{{${option}}}`, 'g'), options[option]), value);
}
//# sourceMappingURL=translate.js.map